import React from 'react';
import './landigs.scss';

export default function Landig({ children }) {

    return (
        <div className='landig'>
            {children}
        </div>
    );
}
